import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class FeelingEvasDeclaredJournalEvent extends JournalEvent {
  static override type = "feeling-evas-declared-journal-event";

  @attr("number") declare mood: number;

  @attr("number") declare energy: number;

  @attr("number") declare irritability: number;

  @attr("number") declare sleepDuration: number;

  @attr("number") declare anxiety: number;

  static override validations(intl: IntlService) {
    return {
      mood: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.feeling-evas-declared-journal-event.mood"
          )
        }),
        validateNumber({
          description: intl.t(
            "validations.feeling-evas-declared-journal-event.mood"
          )
        })
      ],
      energy: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.feeling-evas-declared-journal-event.energy"
          )
        }),
        validateNumber({
          description: intl.t(
            "validations.feeling-evas-declared-journal-event.energy"
          )
        })
      ],
      irritability: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.feeling-evas-declared-journal-event.irritability"
          )
        }),
        validateNumber({
          description: intl.t(
            "validations.feeling-evas-declared-journal-event.irritability"
          )
        })
      ],
      sleepDuration: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.feeling-evas-declared-journal-event.sleep-duration"
          )
        }),
        validateNumber({
          description: intl.t(
            "validations.feeling-evas-declared-journal-event.sleep-duration"
          )
        })
      ],
      anxiety: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.feeling-evas-declared-journal-event.anxiety"
          )
        }),
        validateNumber({
          description: intl.t(
            "validations.feeling-evas-declared-journal-event.anxiety"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.feeling-evas-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "feelingEvasDeclaredJournalEvents"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "feeling-evas-declared-journal-event": FeelingEvasDeclaredJournalEvent;
  }
}
